// Configuration constants for VerDict AI frontend

// REACT_APP_API_URL is baked in at build time.
// Set it in .env (local) or via --build-arg / CI env var before `npm run build`.
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
export const API_BASE_URL = `${API_URL}/v1`;
export const API_VERSION = "v1";

// User query limits - REMOVED hardcoded limit
// Now dynamically fetched from backend /status endpoint
// Backend controls via UNLIMITED_QUERIES environment variable

// Application metadata
export const APP_NAME = "VerDict AI";
export const APP_DESCRIPTION = "AI-powered news verification";
